// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___-IC3K","main":"styles-module__main___ziSv+"};